import { render, staticRenderFns } from "./Resumoped.vue?vue&type=template&id=1115204c&"
import script from "./Resumoped.vue?vue&type=script&lang=js&"
export * from "./Resumoped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports